module.exports = __webpack_public_path__ + "static/productpage-m-72d385ca3d39bfbe4ab7b90eb13b9905.png";